var APIBASEURL = "/dr/cc/vf/";
GLOBALURLS = {
    APIURL: {
        CHECKLOGIN: APIBASEURL + "userinfo/?_sd=fail",
        USERINFO: APIBASEURL + "userinfo/vfplan.ftl",
        LOGIN: "/dr/tmpl/login",
        LOGOUT: "/dr/tmpl/logout",
    },
    PAGEURL: {
        FAILTARIFF:
            "/privat/handys-tablets-tarife/altersnachweis-legitimation-fail-tariff.html",
        FAIL: "/privat/handys-tablets-tarife/altersnachweis-legitimation-fail.html",
        UPLOAD: "/dr/cc/vf/dummy/taf/yoloupload",
    },
};
